import React, { Component } from "react";
import PropTypes from "prop-types";
import queryString from "query-string";
import Multiselect from "components/Multiselect";
import { CustomDateRange } from "components/date-range/index";
import { AppSettings } from "../../constants";
import Translate from "components/translate";

const convertStringMultiParamsToSelectedOption = (stringParams) => {
  let selectedOption = [];
  if (stringParams) {
    const parsedParams = queryString.parse(stringParams);

    Object.keys(parsedParams).map((el) => {
      selectedOption.push(queryString.parse(parsedParams[el]));
    });
  }
  return selectedOption;
};

class LotFilter extends Component {
  static propTypes = {
    RegionSelectList: PropTypes.array,
    onFetchRegion: PropTypes.func,
    MarketSelectList: PropTypes.array,
    onFetchMarket: PropTypes.func,
    ProjectSelectList: PropTypes.array,
    onFetchProject: PropTypes.func,
    onSearchLot: PropTypes.func,
    HomeownerSelectList: PropTypes.array,
    onFetchHomeowner: PropTypes.func,
    location: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.lotStatusSelectList = [
      { label: "Not Sold", value: "0" },
      { label: "Sold", value: "1" },
    ];

    this.queryParams = queryString.parse(props.location.search);

    this.state = {
      region: convertStringMultiParamsToSelectedOption(
        this.queryParams.inRegions
      ),
      isLoadingRegion: false,
      market: convertStringMultiParamsToSelectedOption(
        this.queryParams.inMarkets
      ),
      isLoadingMarket: false,
      project: convertStringMultiParamsToSelectedOption(
        this.queryParams.inProjects
      ),
      isLoadingProject: false,
      coeFrom: null,
      coeTo: null,
      LotStatusSelectList: this.lotStatusSelectList,
      lotStatus: this.queryParams.status
        ? this.lotStatusSelectList.filter((x) =>
            this.queryParams.status.includes(x.value)
          )
        : [],
      homeowner: convertStringMultiParamsToSelectedOption(
        this.queryParams.inHomeowners
      ),
      isLoadingHomeowner: false,
      coeDate:
        this.queryParams.COEDateFrom && this.queryParams.COEDateFrom
          ? {
              from: this.queryParams.COEDateFrom,
              to: this.queryParams.COEDateTo,
              optionType: this.queryParams.COEDateType,
            }
          : null,
    };
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleHideDateRange);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.RegionSelectList && this.state.isLoadingRegion) {
      this.setState({ isLoadingRegion: false });
    }
    if (nextProps.MarketSelectList && this.state.isLoadingMarket) {
      this.setState({ isLoadingMarket: false });
    }
    if (nextProps.ProjectSelectList && this.state.isLoadingProject) {
      this.setState({ isLoadingProject: false });
    }
    if (nextProps.HomeownerSelectList && this.state.isLoadingHomeowner) {
      this.setState({ isLoadingHomeowner: false });
    }

    const prevUrlParams = queryString.parse(this.props.location.search);
    const nextUrlParams = queryString.parse(nextProps.location.search);

    if (nextUrlParams.inProjects !== prevUrlParams.inProjects) {
      this.setState({
        project: convertStringMultiParamsToSelectedOption(
          nextUrlParams.inProjects
        ),
      });
    }

    if (nextUrlParams.inRegions !== prevUrlParams.inRegions) {
      this.setState({
        region: convertStringMultiParamsToSelectedOption(
          nextUrlParams.inRegions
        ),
      });
    }

    if (nextUrlParams.inMarkets !== prevUrlParams.inMarkets) {
      this.setState({
        market: convertStringMultiParamsToSelectedOption(
          nextUrlParams.inMarkets
        ),
      });
    }

    if (nextUrlParams.inHomeowners !== prevUrlParams.inHomeowners) {
      this.setState({
        homeowner: convertStringMultiParamsToSelectedOption(
          nextUrlParams.inHomeowners
        ),
      });
    }

    if (nextUrlParams.status !== prevUrlParams.status) {
      if (nextUrlParams.status) {
        this.setState({
          lotStatus: this.lotStatusSelectList.filter((x) =>
            nextUrlParams.status.includes(x.value)
          ),
        });
      } else {
        this.setState({ lotStatus: [] });
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleHideDateRange);
  }

  onFetchRegion = () => {
    this.setState(
      {
        isLoadingRegion: true,
      },
      () => {
        this.props.onFetchRegion();
      }
    );
  };

  onSelectRegion = (value) => {
    this.setState(
      {
        region: value,
      },
      () => {
        this.props.onSearchLot(this.mapParams());
      }
    );
  };

  onFetchMarket = () => {
    this.setState(
      {
        isLoadingMarket: true,
      },
      () => {
        this.props.onFetchMarket();
      }
    );
  };

  onSelectMarket = (value) => {
    this.setState(
      {
        market: value,
      },
      () => {
        this.props.onSearchLot(this.mapParams());
      }
    );
  };

  onFetchProject = () => {
    this.setState(
      {
        isLoadingProject: true,
      },
      () => {
        this.props.onFetchProject();
      }
    );
  };

  onSelectProject = (value) => {
    this.setState(
      {
        project: value,
      },
      () => {
        this.props.onSearchLot(this.mapParams());
      }
    );
  };

  onSelectLotStatus = (value) => {
    this.setState(
      {
        lotStatus: value,
      },
      () => {
        this.props.onSearchLot(this.mapParams());
      }
    );
  };

  onSaveCOE = (fromDate, toDate, optionType) => {
    if (fromDate && toDate) {
      this.setState(
        {
          coeDate: {
            from: fromDate,
            to: toDate,
            optionType: optionType.value,
          },
        },
        () => {
          this.props.onSearchLot(this.mapParams());
        }
      );
    } else {
      this.setState(
        {
          coeDate: null,
        },
        () => {
          this.props.onSearchLot(this.mapParams());
        }
      );
    }
  };

  onFetchHomeowner = () => {
    this.setState(
      {
        isLoadingHomeowner: true,
      },
      () => {
        this.props.onFetchHomeowner();
      }
    );
  };

  onSelectHomeowner = (value) => {
    this.setState(
      {
        homeowner: value,
      },
      () => {
        this.props.onSearchLot(this.mapParams());
      }
    );
  };

  mapParams = () => {
    let params = {};

    if (this.state.region.length > 0) {
      params["inRegions"] = queryString.stringify([
        ...this.state.region.map((el) => queryString.stringify(el)),
      ]);
    }

    if (this.state.market.length > 0) {
      params["inMarkets"] = queryString.stringify([
        ...this.state.market.map((el) => queryString.stringify(el)),
      ]);
    }

    if (this.state.project.length > 0) {
      params["inProjects"] = queryString.stringify([
        ...this.state.project.map((el) => queryString.stringify(el)),
      ]);
    }

    if (this.state.homeowner.length > 0) {
      params["inHomeowners"] = queryString.stringify([
        ...this.state.homeowner.map((el) => queryString.stringify(el)),
      ]);
    }

    const statuses = [];
    if (this.state.lotStatus.length > 0) {
      this.state.lotStatus.map((e) => {
        statuses.push(e.value);
      });
    }
    statuses.length
      ? (params["status"] = statuses.toString())
      : (params["status"] = "");

    if (this.state.coeDate) {
      params["COEDateFrom"] = this.state.coeDate.from;
      params["COEDateTo"] = this.state.coeDate.to;
      params["COEDateType"] = this.state.coeDate.optionType;
    } else {
      params["COEDateFrom"] = "";
      params["COEDateTo"] = "";
    }

    return params;
  };

  render() {
    const urlParams = queryString.parse(this.props.location.search);

    return (
      <div className="lot-filter-wrapper box-form-siteone clearfix">
        <h2 className="col-sm-12" style={{ fontSize: 20, fontWeight: 400 }}>
          Filters
        </h2>
        <div className="row" style={{ paddingLeft: 15, paddingRight: 15 }}>
          {/*
           * Regions dropdown
           */}
          {(AppSettings.REGION_AND_MARKET ===
            AppSettings.RegionAndMarket.REGION ||
            AppSettings.REGION_AND_MARKET ===
              AppSettings.RegionAndMarket.REGION_AND_MARKET) && (
            <div className="col-sm-3 lot-filter-block">
              <label className="col-sm-12 control-label">
                <Translate plurals translateKey="region" capitalize />
              </label>
              <div className="col-sm-12 control-label">
                <Multiselect
                  placeholder="Any"
                  items={this.props.RegionSelectList.map((item) => ({
                    label: item.text,
                    value: item.value,
                  }))}
                  value={this.state.region}
                  onChange={this.onSelectRegion}
                  onRemote={this.onFetchRegion}
                  isLoading={this.state.isLoadingRegion}
                  ref={(ref) => {
                    this.project = ref;
                  }}
                />
              </div>
            </div>
          )}

          {/*
           * Markets dropdown
           */}
          {AppSettings.REGION_AND_MARKET ===
            AppSettings.RegionAndMarket.REGION_AND_MARKET && (
            <div className="col-sm-3 lot-filter-block">
              <label className="col-sm-12 control-label">
                <Translate translateKey="market" plurals capitalize />
              </label>
              <div className="col-sm-12 control-label">
                <Multiselect
                  placeholder="Any"
                  items={this.props.MarketSelectList.map((item) => ({
                    label: item.text,
                    value: item.value,
                  }))}
                  value={this.state.market}
                  onChange={this.onSelectMarket}
                  onRemote={this.onFetchMarket}
                  isLoading={this.state.isLoadingMarket}
                  ref={(ref) => {
                    this.project = ref;
                  }}
                />
              </div>
            </div>
          )}

          {/*
           * Projects dropdown
           */}
          <div className="col-sm-3 lot-filter-block">
            <label className="col-sm-12 control-label">
              <Translate translateKey="project" plurals capitalize />
            </label>
            <div className="col-sm-12 control-label">
              <Multiselect
                placeholder="Any"
                items={this.props.ProjectSelectList}
                labelKey="text"
                value={this.state.project}
                onChange={this.onSelectProject}
                onRemote={this.onFetchProject}
                isLoading={this.state.isLoadingProject}
                ref={(ref) => {
                  this.project = ref;
                }}
              />
            </div>
          </div>

          {/*
           * Original COE dropdown
           */}
          <div className="col-sm-2 lot-filter-block">
            <label className="col-sm-12 control-label">Original COE</label>
            <CustomDateRange
              ref={(ref) => {
                this.coe = ref;
              }}
              className="col-sm-12"
              startDate={urlParams.COEDateFrom ? urlParams.COEDateFrom : null}
              endDate={urlParams.COEDateTo ? urlParams.COEDateTo : null}
              optionType={urlParams.COEDateType ? urlParams.COEDateType : null}
              onSave={this.onSaveCOE}
            />
          </div>
        </div>
        <div className="row" style={{ paddingLeft: 15, paddingRight: 15 }}>
          {/*
           * Lot statuses dropdown
           */}
          <div className="col-sm-3 lot-filter-block">
            <label className="col-sm-12 control-label">
              <Translate translateKey="lot" capitalize /> status
            </label>
            <div className="col-sm-12 control-label">
              <Multiselect
                placeholder="Any"
                items={this.state.LotStatusSelectList}
                value={this.state.lotStatus}
                onChange={this.onSelectLotStatus}
                ref={(ref) => {
                  this.lotStatus = ref;
                }}
              />
            </div>
          </div>

          {/*
           * Homeowner dropdown
           */}
          <div className="col-sm-3 lot-filter-block">
            <label className="col-sm-12 control-label">
              <Translate translateKey="homeowner" capitalize plurals />
            </label>
            <div className="col-sm-12 control-label">
              <Multiselect
                placeholder="Any"
                items={this.props.HomeownerSelectList.map((item) => ({
                  label: item.text,
                  value: item.value,
                }))}
                value={this.state.homeowner}
                onChange={this.onSelectHomeowner}
                onRemote={this.onFetchHomeowner}
                isLoading={this.state.isLoadingHomeowner}
                ref={(ref) => {
                  this.homeowner = ref;
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LotFilter;



// WEBPACK FOOTER //
// ./src/Lots/Components/lot-filter.js